import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
} from '@growdash/design-system/atoms';
import { CardElement } from '@stripe/react-stripe-js';
import { Stripe, StripeElements } from '@stripe/stripe-js';

interface AddPaymentMethodDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onAddCard: () => void;
  isSubmitting: boolean;
  stripe: Stripe | null;
  elements: StripeElements | null;
  newCardName: string;
  setNewCardName: (name: string) => void;
  stripeError: string | null;
  setStripeError: (error: string | null) => void;
  cardComplete: boolean;
  setCardComplete: (complete: boolean) => void;
  cardElementOptions: any; // Consider creating a more specific type for this
}

export function AddPaymentMethodDialog({
  isOpen,
  setIsOpen,
  onAddCard,
  isSubmitting,
  stripe,
  elements,
  newCardName,
  setNewCardName,
  stripeError,
  setStripeError,
  cardComplete,
  setCardComplete,
  cardElementOptions,
}: AddPaymentMethodDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      {/* The DialogTrigger will be handled by the parent component */}
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add Payment Method</DialogTitle>
          <DialogDescription>
            Enter your card details to add a new payment method.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="cardName">Card Name (Optional)</Label>
            <Input
              id="cardName"
              placeholder="Personal Card, Business Card, etc."
              value={newCardName}
              onChange={(e) => setNewCardName(e.target.value)}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="card-element">Card Details</Label>
            <div
              className={`border rounded-md p-3 ${
                stripeError ? 'border-destructive' : 'border-input'
              }`}
            >
              <CardElement
                id="card-element"
                options={cardElementOptions}
                onChange={(event) => {
                  setStripeError(event.error ? event.error.message : null);
                  setCardComplete(event.complete);
                }}
              />
            </div>
            {stripeError && (
              <p className="text-sm text-destructive mt-1">{stripeError}</p>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => setIsOpen(false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            onClick={onAddCard}
            disabled={!stripe || !elements || isSubmitting || !cardComplete}
          >
            {isSubmitting ? 'Adding...' : 'Add Card'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
